import { JSA_FORM_MODE_REVIEW, ManageJsaReportFormDialog } from '../ManageJsaReport/ManageJsaReportFormDialog';
import type { IUseJsaReviewResults } from './hooks/useJsaReview';

export default function JsaReviewDialog({ jsaReviewDialog, props }: IUseJsaReviewResults) {
  return <ManageJsaReportFormDialog jsaFormMode={JSA_FORM_MODE_REVIEW} openable={jsaReviewDialog} {...props} />;
}
